import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global styles
const style = document.createElement('style');
style.textContent = `
  *, *::before, *::after { box-sizing: border-box; }
  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
    -webkit-font-smoothing: antialiased;
    color: #1A202C;
    font-size: 14px;
    line-height: 1.5;
  }
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  input:focus, select:focus {
    border-color: #319795 !important;
    box-shadow: 0 0 0 1px #319795;
  }
  a { color: #319795; }
  ::selection { background: #BEE3F8; }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
